import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import error from './../images/error.svg'

const DisplayInvoicesError = (props) => {
  return (
    <>
      {/* <div className='mainTitle'>{props.mainTitle}</div> */}
      <div className="display-invoices-error-container">
        <Image src={error} alt="Error Icon" className="icon" />
        <div className="text-container">
          <div className="error-text">נראה שמשהו השתבש, אנחנו על זה</div>
          <div className="secondary-error-text">בינתיים אפשר לנסות ולרענן את העמוד שוב</div>
        </div>
      </div>
    </>
  );
};
export default DisplayInvoicesError;
